import ChangePassword from "views/ChangePassword";
import Interpreters from "views/Interpreters";
import Dashboard from "views/Dashboard";
import Reports from "views/Reports";
import ClientType from "views/clients/Accounts";
import { AppointmentRoutes } from "views/Appointment";
import { BillingualRoutes } from "views/BillingualRequests";
import LanguageList from "views/tools/language";
import StateList from "views/tools/state";
import CityList from "views/tools/city";
import CreateAccount from "views/clients/accounts/Create";
import UpdateAccount from "views/clients/accounts/Update";
import PermissionGroups from "views/permissions/Groups";
import PermissionSubUser from "views/permissions/SubUsers";
import UpdateGroup from "views/permissions/groups/Update";
import CreateGroup from "views/permissions/groups/Create";
import VendorList from "views/clients/vendors";
import Facility from "components/type/facilities/Facility";
import Department from "components/type/departments/Departments";
import Translation from "views/Translation/Translation";
import InvoicePayments from "views/InvoicePayments";
import InvoiceAppointmentDetail from "views/InvoicePayments/InvoiceApptDetail";
import PdfView from "views/InvoicePayments/PdfView";
import AllPdfView from "views/AllInvoices/PdfView";
import InvocieList from "views/AllInvoices/AllInvoices";
import IntepreterPayments from "views/Payments/InterpreterPayments";
import VendorPayments from "views/Payments/VendorPayments";
import SchoolList from "views/tools/school";
import ZoneList from "views/tools/zone";
import TranslationView from "views/Translation/TranslationView";
import ExcelAppointments from "views/ExcelAppointments";


var routes = [
  {
    path: "",
    title: "Dashboard",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <Dashboard />,
    layout: "/",
  },
  // {
  //   path: "appointments",
  //   title: "Appointments",
  //   icon: "/images/Reports.png",
  //   iconActive: "/images/Reports-fill.png",
  //   component: <AppointmentRoutes />,
  //   layout: "",
  // },
  {
    path: "billingual-requests",
    title: "Bilingual Requests",
    icon: "/images/file-contract-regular.svg",
    iconActive: "/images/file-contract-solid.svg",
    component: <BillingualRoutes />,
    layout: "",
  },
  {
    path: "excel-appointments",
    title: "Excel Appointments",
    icon: "/images/file-contract-regular.svg",
    iconActive: "/images/file-contract-solid.svg",
    component: <ExcelAppointments />,
    layout: "/",
  },
  {
    path: "translations",
    title: "Translations",
    subRoute: false,
    icon: "/images/meeting-place.png",
    iconActive: "/images/meeting-place-active.png",
    component: <Translation />,
    layout: "/",
  },
  {
    path: "translation/view/:id",
    subRoute: true,
    component: <TranslationView />,
    layout: "/",
  },
  {
    path: "clients/accounts",
    title: "Accounts",
    subRoute: true,
    icon: "/images/meeting-place.png",
    iconActive: "/images/meeting-place-active.png",
    component: <ClientType />,
    layout: "",
  },
  {
    path: "clients/accounts/create",
    subRoute: true,
    component: <CreateAccount />,
    layout: "/admin",
  },
  {
    path: "clients/accounts/facilities/:id",
    subRoute: true,
    component: <Facility />,
    layout: "/admin",
  },
  {
    path: "clients/accounts/departments/:id",
    subRoute: true,
    component: <Department />,
    layout: "/admin",
  },
  {
    path: "clients/accounts/update/:id",
    subRoute: true,
    component: <UpdateAccount />,
    layout: "/admin",
  },
  // {
  //   path: "billings",
  //   title: "Billings",
  //   icon: "/images/Reports.png",
  //   iconActive: "/images/Reports-fill.png",
  //   component: <InvoicePayments />,
  //   layout: "",
  // },
  // {
  //   path: "billings/detail/:id",
  //   subRoute: true,
  //   component: <InvoiceAppointmentDetail />,
  //   layout: "/admin",
  // },
  // {
  //   path: "billings/pdf-view/:id",
  //   subRoute: true,
  //   component: <PdfView />,
  //   layout: "/admin",
  // },
  // {
  //   path: "invoices",
  //   title: "Invoices",
  //   icon: "/images/Reports.png",
  //   iconActive: "/images/Reports-fill.png",
  //   component: <InvocieList />,
  //   layout: "",
  // },
  // {
  //   path: "invoices/pdf-view/:id",
  //   subRoute: true,
  //   component: <AllPdfView />,
  //   layout: "/admin",
  // },
  {
    path: "interpreters",
    title: "Interpreters",
    icon: "/images/calendar-view.png",
    iconActive: "/images/calendar-view.png",
    component: <Interpreters />,
    layout: "/",
  },
  {
    path: "vendors",
    title: "Vendors",
    icon: "/images/admin.png",
    iconActive: "/images/admin-active.png",
    component: <VendorList />,
    layout: "",
  },
  // {
  //   path: "interpreter-payments",
  //   title: "Interpreter Payments",
  //   icon: "/images/meeting-place.png",
  //   iconActive: "/images/meeting-place-active.png",
  //   component: <IntepreterPayments />,
  //   layout: "",
  // },
  // {
  //   path: "vendor-payments",
  //   title: "Vendor Payments",
  //   icon: "/images/meeting-place.png",
  //   iconActive: "/images/meeting-place-active.png",
  //   component: <VendorPayments />,
  //   layout: "",
  // },
  {
    path: "reports",
    title: "Reports",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <Reports />,
    layout: "/",
  },
  {
    path: "permissions/groups",
    title: "Groups",
    subRoute: true,
    icon: "/images/meeting-place.png",
    iconActive: "/images/meeting-place-active.png",
    component: <PermissionGroups />,
    layout: "/",
  },
  {
    path: "permissions/groups/create",
    subRoute: true,
    component: <CreateGroup />,
    layout: "/admin",
  },
  {
    path: "permissions/groups/update/:id",
    subRoute: true,
    component: <UpdateGroup />,
    layout: "/admin",
  },

  {
    path: "permissions/sub-users",
    title: "Sub Users",
    subRoute: true,
    icon: "/images/admin.png",
    iconActive: "/images/admin-active.png",
    component: <PermissionSubUser />,
    layout: "",
  },

  // {
  //   path: "tools/city",
  //   subRoute: true,
  //   component: <CityList />,
  //   layout: "/admin",
  // },
  {
    path: "tools/school",
    subRoute: true,
    component: <SchoolList />,
    layout: "/admin",
    name: "Schools"
  },
  {
    path: "tools/zone",
    subRoute: true,
    component: <ZoneList />,
    layout: "/admin",
    name: "Zones"
  },
  {
    path: "tools/state",
    subRoute: true,
    component: <StateList />,
    layout: "/admin",
  },
  {
    path: "tools/language",
    subRoute: true,
    component: <LanguageList />,
    layout: "/admin",
  },
  {
    path: "change-password",
    subRoute: true,
    component: <ChangePassword />,
    layout: "/",
  }
];
export default routes;
